@if (!transportConfiguration?.Id) {
  <h4 class="modal-title">New Location</h4>
}
@if (transportConfiguration?.Id) {
  <h4 class="modal-title">Edit: {{transportConfiguration?.Name}}</h4>
}
<hr />

<form [formGroup]="transportTypeFormGroup" name="transportTypeForm" (ngSubmit)="save()" novalidate>
  <fieldset [disabled]="readonly">

    <!-- Standard -->

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label>Name *</label>
          <input id="newLocationName" formControlName="inputName" class="form-control" type="text" [ngModel]="$safeNavigationMigration(clonedTransportConfiguration?.Name)"
            (ngModelChange)="clonedTransportConfiguration && clonedTransportConfiguration.Name = $event" />
            @if (!transportTypeFormGroup.controls['inputName'].valid) {
              <div class="error">Please enter a name</div>
            }
          </div>
        </div>

        <div class="col-sm-4">
          <label>Transport Type</label>
          <select class="form-control" [ngModelOptions]="{standalone: true}" [ngModel]="$safeNavigationMigration(clonedTransportConfiguration?.TransportTypeId)"
            (ngModelChange)="clonedTransportConfiguration.TransportTypeId = $event; transportTypeFormGroup.controls['transportTypeId'].setValue($event); transportTypeChanged()">
            <option [ngValue]="null">Please choose...</option>
            @for (transportType of transportTypes; track transportType) {
              <option [ngValue]="transportType.Id">{{transportType.Name}}</option>
            }
          </select>
          @if (!transportTypeFormGroup.controls['transportTypeId'].valid) {
            <div class="error">Please choose a transport type</div>
          }
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label>Partner System</label>
            <select [ngModelOptions]="{standalone: true}" id="partnerSystem" class="form-control" [ngModel]="$safeNavigationMigration(clonedTransportConfiguration?.PartnerSystemId)"
              (ngModelChange)="partnerSystemChanged($event)">
              <option [ngValue]="null">Select...</option>
              @for (partnerSystem of partnerSystems; track partnerSystem) {
                <option [ngValue]="partnerSystem.Id">{{partnerSystem.Name}}</option>
              }
            </select>
          </div>
        </div>
      </div>

      @if (!partnerRestrictedMode) {
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label>Partner</label>
              <ep-partner-selector [(selectedPartner)]="clonedPartner" [isReadOnly]="readonly || !allowPartnerChange"
              (selectedPartnerChange)="partnerChanged($event)"></ep-partner-selector>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <div class="control control-checkbox lg control-form-group">
                <label>Is Global
                  <input type="checkbox" [ngModelOptions]="{standalone: true}" [disabled]="isGlobal || !allowPartnerChange" [ngModel]="isGlobal"
                    (ngModelChange)="isGlobalChanged($event)" />
                    <i></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
        }

        <!-- Datafields -->
        <div class="row mb-2">
          <div class="col-sm-12">
            <ep-datafield-group-container [formValidationGroup]="dataFieldsFormGroup" [showError]="showError" [datafieldGroups]="transportConfigDataGroups"
            [isAlwaysEditable]="true" [numberOfColumns]="3"></ep-datafield-group-container>
          </div>
        </div>

        <!-- Monitor -->
        @if (currentHasMonitor) {
          <div class="row mb-2">
            <div class="col-sm-12">
              <div class="embeddedItem">
                <h2>Monitoring</h2>
                <app-monitor-item-edit formControlName="monitorItem" [stakeholders]="stakeholders" [monitorSchedules]="monitorSchedules"
                  [monitorGroups]="monitorGroups" [embeddedArtifactId]="getSelectedTransportTypeArtifactId()" [ngModel]="$safeNavigationMigration(clonedTransportConfiguration?.MonitorItem)"
                  (ngModelChange)="clonedTransportConfiguration && clonedTransportConfiguration.MonitorItem = $event">
                </app-monitor-item-edit>
              </div>
            </div>
          </div>
        }
        @if (currentTransportTypeSupportsMonitor || currentHasMonitor) {
          <div class="row mb-2">
            <div class="col-sm-12">
              <div class="btn-toolbar">
                <button type="button" class="btn btn-primary" [disabled]="currentHasMonitor" (click)="addMonitor()">Add monitor</button>
                <button type="button" class="btn btn-primary" [disabled]="!currentHasMonitor" (click)="removeMonitor()">Remove monitor</button>
              </div>
            </div>
          </div>
        }

        <!-- Bottom Toolbar -->
        <div class="row mb-2">
          <div class="col-sm-12">
            <div class="btn-toolbar">
              <button id="btnSaveLocation" type="submit" class="btn btn-primary">Save</button>
              <button id="btnCancelLocation" type="button" class="btn btn-link" (click)="cancel()">Cancel</button>
            </div>
          </div>
        </div>

      </fieldset>
    </form>
